import { AnalyticsAction, AnalyticsActionSubject, AnalyticsActionSubjectId } from '../../../types';
import { BaseInvitePeopleAnalytics } from '../../../analytics';

export class InvitePeoplePluginsAnalytics extends BaseInvitePeopleAnalytics {
	pluginsValidationFailed({ error }: { error: string }): void {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.VALIDATION,
			actionSubjectId: AnalyticsActionSubjectId.PLUGINS,
			action: AnalyticsAction.FAILED,
			attributes: { error },
		});
	}
}
